import { BannerTypeMap } from "@/constants/investment";
import { Badge, Box, Flex, HStack, Image, VStack } from "@chakra-ui/react";
import { formatSecurities, offeringHidesSecurityLabel, offeringIsTerminated } from "@equidefi/shared";
import { Heading, Text } from "@equidefi/ui";
import { CurrencyFormatter } from "../../constants/format";
import Continue from "./continue";
import { useMemo } from "react";

const StatusBadge = ({ action }) => {
  return (
    <Badge
      h="6"
      lineHeight="6"
      fontSize="14px"
      justifyContent="center"
      bgColor={BannerTypeMap[action] || "equidefi.yellow"}
      w="full"
      textAlign="center">
      {action}
    </Badge>
  );
};

const InvestmentCard = ({
  investment,
  issuer,
  offering,
  cardAction,
  hideStatusBadge = false,
  hideResumeButton = false,
}) => {
  if (!investment) {
    return null;
  }

  const issuerData = issuer || investment?.issuer;
  const offeringData = offering || investment?.offering;
  const hideSecurityLabel = offeringHidesSecurityLabel(offeringData);

  const isOfferingTerminated = offeringIsTerminated(offeringData);

  const status = useMemo(() => {
    if (investment?.status === "CANCELED") {
      return "CANCELED";
    }

    if (investment?.status === "CLOSED") {
      return "COMPLETED";
    }

    if (investment?.countersignature_status === "pending") {
      return "PROCESSING";
    }

    return "INCOMPLETE";
  }, [investment]);

  return (
    <Box
      w="full"
      h="auto"
      borderRadius="8px"
      bg="linear-gradient(150deg, black 0%, #3e3e3e 100%)"
      p="4"
      color="white"
      onClick={cardAction}
      cursor={cardAction ? "pointer" : null}>
      {!hideStatusBadge && <StatusBadge w="full" textAlign="center" action={status} />}

      <VStack gap="2.5" minW="full" mt="3">
        <Flex minW="full">
          <Image
            mr="2.5"
            mb="0"
            w="50px"
            h="50px"
            borderRadius="4px"
            bg="white"
            objectFit="contain"
            p="1"
            src={issuerData?.photo_url}
            alt={"logo"}
          />
          <Box>
            <Heading mb="0" textStyle="h3" fontWeight="bold">
              {issuerData?.name}
            </Heading>
            <HStack>
              <Text m="0" textStyle="h2" fontWeight="bold">{`${CurrencyFormatter.format(investment?.amount)}`}</Text>
              {!hideSecurityLabel && (
                <Text m="0">
                  {" "}
                  {` • ${formatSecurities({
                    quantity: investment?.quantity,
                    offering: offeringData,
                  }).toString()}`}
                </Text>
              )}
            </HStack>
          </Box>
        </Flex>

        <Text mb="0" ml={{ base: 1, lg: 0 }} textStyle="body2" alignSelf="start">
          {offeringData?.name}
        </Text>

        {!hideStatusBadge && !hideResumeButton && !isOfferingTerminated && (
          <Continue investment={investment} offering={offeringData} />
        )}
      </VStack>
    </Box>
  );
};

export default InvestmentCard;
